import React, { createContext, useContext, useMemo } from 'react'
import { NoticeLoading } from '@fs/zion-icon'
import { usePermission } from '@fs/zion-permissions'

export const permissionsContext = createContext(() => {})

const permissionContext = 'HelpPermit'
const moderatorPermission = 'ViewAllHelpRequests'
const helperPermission = 'ViewUnassignedHelpRequests'

export default function QueuePermissionsProvider({ children }) {
  const [isModerator, adminStatus] = usePermission(moderatorPermission, permissionContext)
  const [isHelper, helperStatus] = usePermission(helperPermission, permissionContext)
  const adminLoading = adminStatus === 'loading'
  const helpLoading = helperStatus === 'loading'

  const contextValue = useMemo(() => ({ isModerator, isHelper }), [isModerator, isHelper])

  return (
    <permissionsContext.Provider value={contextValue}>
      {(adminLoading || helpLoading) && <NoticeLoading />}
      {Boolean(!helpLoading && !adminLoading) && children}
    </permissionsContext.Provider>
  )
}

export function useQueuePermissionsContext() {
  return useContext(permissionsContext)
}
